module.exports = __webpack_public_path__ + "98dde06d1092d160e6d8d017815b7a42.pdf";